import { useContext } from "react";
import { FormTypeContext } from "./tab/RouletteItemDesignTab";
import { Box, FormField, Select, Tab, Tabs, TextInput } from "grommet";
import { SettingType } from "./utils/SettingType";
import { rouletteItemFrameType } from "../RouletteConstants";
import { ImageSettingsForm } from "./sections/ImageSettingsForm";
import { BoxShadow } from "../../../icons/BoxShadow";
import ShadowSettingsForm from "./sections/ShadowSettingsForm";
import RangeInputWithEdit from "../../../forms/RangeInputWithEdit";
import { Checkbox, Close, Image } from "grommet-icons";
import { CircleHalfFull } from "../../../icons/CircleHalfFull";
import { RulerSquare } from "../../../icons/RulerSquare";
import { useTranslation } from "react-i18next";

const typeOptions = [
    { labelKey: 'optionNone', icon: <Close />, value: rouletteItemFrameType.NONE },
    { labelKey: 'optionOutline', icon: <Checkbox />, value: rouletteItemFrameType.OUTLINE },
    { labelKey: 'optionImage', icon: <Image />, value: rouletteItemFrameType.IMAGE },
]

const RouletteFrameSettings = () => {

    const { t } = useTranslation('roulette');
    const { frameType: type } = useContext(FormTypeContext);

    return (
        <Box gap="medium">
            <FormField label={t('typeLabel')}>
                <Select
                    name="frameType"
                    options={typeOptions} 
                    labelKey={(option) => <SettingType option={{ ...option, label: t(option.labelKey) }} />}
                    valueKey={{ key: 'value', reduce: true }}
                    // value={type}
                    // onChange={({ value }) => setType(value)}
                />
            </FormField>
            {type !== rouletteItemFrameType.NONE && <FrameSettingsForm type={type}/>}
        </Box>
    )
}

export default RouletteFrameSettings;

const FrameSettingsForm = ({ type }) => {

    const { t } = useTranslation('roulette');

    return (
        <Box>
            <Tabs>
                <Tab title={type === rouletteItemFrameType.OUTLINE ? t('outlineTabTitle') : t('imageTabTitle')} icon={type === rouletteItemFrameType.OUTLINE ? <CircleHalfFull /> : <Image/>}>
                    {type === rouletteItemFrameType.OUTLINE && <OutlineSettingsForm />}
                    {type === rouletteItemFrameType.IMAGE && <ImageSettingsForm label={t('frameLabel')} title={t('frameBtnTitle')} imageInputName="frameImage" imageHueInputName="frameImageHueRotate" imageSaturationInputName="frameImageSaturate" category="roulette_frame" />}
                </Tab>
                {type === rouletteItemFrameType.OUTLINE && <Tab title={t('sizeTabTitle')} icon={<RulerSquare />}>
                    <Box background={'background-contrast'} pad={'small'} round={'small'} margin={{ top: 'medium' }}>
                        <FormField label={t('radiusLabel')} noBorder noFocus>
                            <RangeInputWithEdit name="frameRadius" type="number" unit={'px'} min={0} max={50} step={1} />
                        </FormField>
                    </Box>
                </Tab>}
                <Tab title={t('shadowTabTitle')} icon={<BoxShadow/>}>
                    <ShadowSettingsForm 
                        shadowColorInputName="frameShadowColor"
                        shadowHorizontalOffsetInputName="frameShadowHorizontalOffset"
                        shadowVerticalOffsetInputName="frameShadowVerticalOffset"
                        shadowBlurInputName="frameShadowBlur"
                    />
                </Tab>
            </Tabs>
        </Box>
    )
}

const OutlineSettingsForm = () => {

    const { t } = useTranslation('roulette');

    return (
        <Box background={'background-contrast'} pad={'small'} round={'small'} margin={{ top: 'medium' }}>
            <FormField label={t('color1Label')}>
                <TextInput name="frameColor1" type="color" />
            </FormField>
            <FormField label={t('color2Label')}>
                <TextInput name="frameColor2" type="color" />
            </FormField>
            <FormField label={t('angleLabel')} noBorder noFocus>
                <RangeInputWithEdit name="frameColorGradientAngle" type="number" unit={'°'} min={0} max={360} step={1} />
            </FormField>
            <FormField label={t('outlineWidthLabel')} noBorder noFocus>
                <RangeInputWithEdit name="frameOutlineWidth" type="number" unit={'px'} min={0} max={50} step={1} />
            </FormField>
        </Box>
    )
}
